import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Highlight, HighlightType, HighlightVariant } from '@node-space/ui-components'
import { EarnAssetStatCard } from './EarnAssetStatCard'

export interface EarnAssetSummaryDirectProps {
  earnRate: string
  allocatedFunds: string
  myLifetimeEarnings: string
  unallocatedFunds: string
  isStatisticsLoading?: boolean
}

export const EarnAssetSummaryDirect = ({
  earnRate,
  allocatedFunds,
  myLifetimeEarnings,
  unallocatedFunds,
  isStatisticsLoading,
}: EarnAssetSummaryDirectProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gap={16} className="lg:flex-row" testId="earn-asset-summary-direct">
      <EarnAssetStatCard
        icon="CoinArrowInCustom"
        label={t('earn.yourAllocatedFunds')}
        value={allocatedFunds}
        highlight={
          <Highlight type={HighlightType.Feature} variant={HighlightVariant.Emphasis}>
            {t('earn.earningAtRate', { rate: earnRate })}
          </Highlight>
        }
      />
      <EarnAssetStatCard
        icon="SketchLogo"
        label={t('earn.myLifetimeEarnings')}
        value={myLifetimeEarnings}
      />
      <EarnAssetStatCard
        icon="HourglassMedium"
        label={t('earn.unallocatedFunds')}
        value={unallocatedFunds}
        isLoading={isStatisticsLoading}
        testId="earn-unallocated-funds"
      />
    </Box>
  )
}
